module.exports = __webpack_public_path__ + "img/wenzi1.967f48d9.webp";